// Centralized route configuration for automatic synchronization
// URL SIMPLIFICATION: New short URLs with redirects from old URLs
export const routeConfig = {
  // Main application routes
  main: {
    home: {
      path: '/',
      name: 'Strategic Command Center',
      component: 'HomepageStrategicCommandCenter',
      title: 'Bootminds - Strategic Command Center',
      description: 'Transform global ambition into Indian excellence'
    },
    strategicHub: {
      commandCenter: {
        path: '/strategic-hub/command-center',
        name: 'Command Center',
        component: 'HomepageStrategicCommandCenter',
        title: 'Strategic Command Center - Bootminds',
        description: 'Central hub for strategic operations and insights',
        redirect: '/' // Redirect to homepage as they are the same content
      }
    },
    // NEW SIMPLIFIED SERVICE ROUTES
    services: {
      // Primary GCC Setup page (Executive Edition) - NEW SHORT URL
      gccSetupNew: {
        path: '/services',
        name: 'GCC Setup Services',
        component: 'GccSetupExecutiveEdition',
        title: 'GCC Setup Services - Executive Edition | Bootminds',
        description: 'Fortune 500-grade GCC in 90 days with zero-risk approach and transparent pricing'
      },
      // REDIRECT: Old comprehensive mastery URL
      gccSetupOld: {
        path: '/gcc-setup-services-comprehensive-mastery',
        name: 'GCC Setup (Legacy)',
        component: 'GccSetupExecutiveEdition',
        title: 'GCC Setup Services',
        description: 'Launch your India GCC in 90 days',
        redirect: '/services'
      },
      // GCC Expansion - NEW SHORT URL
      gccExpansionNew: {
        path: '/services/expansion',
        name: 'GCC Expansion',
        component: 'GCCExpansionServices',
        title: 'GCC Expansion Services | Bootminds',
        description: 'Multi-city expansion, government partnerships, and market intelligence'
      },
      // REDIRECT: Old expansion URL
      gccExpansionOld: {
        path: '/gcc-expansion-services',
        name: 'GCC Expansion (Legacy)',
        component: 'GCCExpansionServices',
        title: 'GCC Expansion Services',
        description: 'Multi-city expansion and government partnerships',
        redirect: '/services/expansion'
      },
      // Executive Hiring - NEW SHORT URL
      executiveHiringNew: {
        path: '/services/executive-hiring',
        name: 'Executive Hiring',
        component: 'ExecutiveHiringLeadershipSearch',
        title: 'Executive Hiring & Leadership Search | Bootminds',
        description: '25-day executive search promise with SkillStack™ assessment'
      },
      // REDIRECT: Old executive hiring URL
      executiveHiringOld: {
        path: '/executive-hiring-leadership-search',
        name: 'Executive Hiring (Legacy)',
        component: 'ExecutiveHiringLeadershipSearch',
        title: 'Executive Hiring & Leadership Search',
        description: '25-day executive search promise',
        redirect: '/services/executive-hiring'
      },
      // SkillStack Staffing - NEW SHORT URL
      staffingNew: {
        path: '/services/staffing',
        name: 'SkillStack Staffing',
        component: 'SkillStackStaffingSolutions',
        title: 'SkillStack Staffing Solutions | Bootminds',
        description: 'Contract, contract-to-hire, and full-time staffing with 25-day delivery guarantee'
      },
      // REDIRECT: Old staffing URL
      staffingOld: {
        path: '/skillstack-staffing-solutions',
        name: 'SkillStack Staffing (Legacy)',
        component: 'SkillStackStaffingSolutions',
        title: 'SkillStack Staffing Solutions',
        description: 'Staffing with 25-day delivery guarantee',
        redirect: '/services/staffing'
      },
      // Engagement Models (part of services now)
      engagementModels: {
        path: '/engagement-models-partnership-framework',
        name: 'Engagement Models',
        component: 'EngagementModelsPartnershipFramework',
        title: 'Engagement Models & Partnership Framework',
        description: 'Five strategic engagement models for GCC setup'
      }
    },
    proofInsights: {
      // Case Studies - NEW SHORT URL
      caseStudiesNew: {
        path: '/case-studies',
        name: 'Case Studies',
        component: 'SuccessStoriesProvenTransformations',
        title: 'Case Studies - Proven GCC Transformations | Bootminds',
        description: 'Transformation case studies, testimonials, and performance metrics'
      },
      // REDIRECT: Old success stories URL
      successStoriesOld: {
        path: '/success-stories-proven-transformations',
        name: 'Success Stories (Legacy)',
        component: 'SuccessStoriesProvenTransformations',
        title: 'Client Outcomes & Proof',
        description: 'Transformation case studies',
        redirect: '/case-studies'
      },
      // ROI Calculator - NEW SHORT URL
      calculatorNew: {
        path: '/calculator',
        name: 'ROI Calculator',
        component: 'RoiCalculatorHubInteractiveDecisionTools',
        title: 'ROI Calculator & Decision Tools | Bootminds',
        description: 'ROI calculators, market intelligence, and knowledge assets'
      },
      // REDIRECT: Old calculator URL
      calculatorOld: {
        path: '/roi-calculator-hub-interactive-decision-tools',
        name: 'ROI Calculator (Legacy)',
        component: 'RoiCalculatorHubInteractiveDecisionTools',
        title: 'ROI & Intelligence Hub',
        description: 'ROI calculators and decision tools',
        redirect: '/calculator'
      },
      // About - NEW SHORT URL
      aboutNew: {
        path: '/about',
        name: 'About Bootminds',
        component: 'AboutUsCompanyFoundationLeadership',
        title: 'About Bootminds | Company & Leadership',
        description: 'Company foundation, leadership, and advisory council'
      },
      // REDIRECT: Old about URL
      aboutOld: {
        path: '/about-us-company-foundation-leadership',
        name: 'About (Legacy)',
        component: 'AboutUsCompanyFoundationLeadership',
        title: 'About Bootminds',
        description: 'Company foundation and leadership',
        redirect: '/about'
      },
      contact: {
        path: '/contact',
        name: 'Contact',
        component: 'ContactPage',
        title: 'Contact Bootminds',
        description: 'Get in touch with Bootminds for GCC consulting services'
      },
      // /team and /advisory-team-expert-credentials are handled as explicit redirects to /about in Routes.jsx
      // Assessment (Engagement Finder) - NEW SHORT URL
      assessmentNew: {
        path: '/assessment',
        name: 'GCC Assessment',
        component: 'EngagementModelsFinder',
        title: 'GCC Assessment Tool | Bootminds',
        description: 'Interactive tool to find your perfect GCC engagement model'
      },
      // REDIRECT: Old finder URL
      assessmentOld: {
        path: '/engagement-models-finder',
        name: 'Engagement Models Finder (Legacy)',
        component: 'EngagementModelsFinder',
        title: 'Find Your Engagement Model',
        description: 'Interactive engagement model finder',
        redirect: '/assessment'
      }
    },
    intelligence: {
      // Market Intelligence - NEW SHORT URL
      marketHubNew: {
        path: '/market-intelligence',
        name: 'Market Intelligence',
        component: 'MarketIntelligenceHubRealTimeInsights',
        title: 'Market Intelligence | Bootminds',
        description: 'Real-time market insights and analytics'
      },
      // REDIRECT: Old market intelligence URL
      marketHubOld: {
        path: '/market-intelligence-hub-real-time-insights',
        name: 'Market Intelligence (Legacy)',
        component: 'MarketIntelligenceHubRealTimeInsights',
        title: 'Market Intelligence Hub',
        description: 'Real-time insights',
        redirect: '/market-intelligence'
      }
    },
    insights: {
      // Resources - NEW SHORT URL
      resourcesNew: {
        path: '/resources',
        name: 'Knowledge Library',
        component: 'ResourcesInsightsKnowledgeAuthority',
        title: 'Resources & Insights | Bootminds',
        description: 'Playbooks, frameworks, and strategic resources'
      },
      // REDIRECT: Old resources URL
      resourcesOld: {
        path: '/resources-insights-knowledge-authority',
        name: 'Resources (Legacy)',
        component: 'ResourcesInsightsKnowledgeAuthority',
        title: 'Knowledge Library & Insights',
        description: 'Knowledge resources',
        redirect: '/resources'
      },
      webinarPlayer: {
        path: '/webinar/:id',
        name: 'Webinar Player',
        component: 'WebinarPlayer',
        title: 'Webinar - Bootminds',
        description: 'Watch expert webinars and educational content'
      }
    },
  },
  // System and utility routes
  system: {
    admin: {
      path: '/admin',
      name: 'Admin Panel',
      component: 'Admin',
      title: 'Admin Panel - Bootminds',
      description: 'Admin panel for content management and visual editing'
    },
    adminAccess: {
      path: '/admin-access',
      name: 'Admin Access',
      component: 'AdminAccess',
      title: 'Admin Access - Bootminds',
      description: 'Admin access verification'
    },
    notFound: {
      path: '*',
      name: '404 - Page Not Found',
      component: 'NotFound',
      title: '404 - Page Not Found',
      description: 'The requested page could not be found'
    },
    privacyPolicy: {
      path: '/privacy-policy',
      name: 'Privacy Policy',
      component: 'PrivacyPolicy',
      title: 'Privacy Policy - Bootminds',
      description: 'Privacy Policy for Bootminds - Global Capability Center consulting services'
    },
    termsOfService: {
      path: '/terms-of-service',
      name: 'Terms of Service',
      component: 'TermsOfService',
      title: 'Terms of Service - Bootminds',
      description: 'Terms of Service for Bootminds - Global Capability Center consulting services'
    },
    cookiesPolicy: {
      path: '/cookies-policy',
      name: 'Cookies Policy',
      component: 'CookiesPolicy',
      title: 'Cookies Policy - Bootminds',
      description: 'Cookies Policy for Bootminds - Learn how we use cookies and tracking technologies'
    }
  }
};

// Route validation and extraction utilities
export const getAllRoutes = () => {
  const routes = [];
  
  const extractRoutes = (obj, prefix = '') => {
    Object.entries(obj).forEach(([key, value]) => {
      if (value.path && value.component) {
        routes.push({
          key: prefix ? `${prefix}.${key}` : key,
          ...value
        });
      } else if (typeof value === 'object' && !value.path) {
        extractRoutes(value, prefix ? `${prefix}.${key}` : key);
      }
    });
  };
  
  extractRoutes(routeConfig);
  return routes;
};

// Get route by path
export const getRouteByPath = (path) => {
  const routes = getAllRoutes();
  return routes.find(route => route.path === path);
};

// Validate route exists
export const validateRoute = (path) => {
  const route = getRouteByPath(path);
  return route ? { valid: true, route } : { valid: false, route: null };
};

// Get all navigation paths for validation
export const getNavigationPaths = () => {
  const routes = getAllRoutes();
  return routes
    .filter(route => !route.redirect && route.path !== '*')
    .map(route => ({
      path: route.path,
      name: route.name,
      title: route.title,
      description: route.description
    }));
};

// Route consistency checker
export const checkRouteConsistency = () => {
  const routes = getAllRoutes();
  const issues = [];
  
  // Check for duplicate paths
  const pathCounts = {};
  routes.forEach(route => {
    if (route.path !== '*') {
      pathCounts[route.path] = (pathCounts[route.path] || 0) + 1;
    }
  });
  
  Object.entries(pathCounts).forEach(([path, count]) => {
    if (count > 1) {
      issues.push({
        type: 'duplicate_path',
        path,
        message: `Duplicate route path: ${path}`
      });
    }
  });
  
  // Check for missing components (would require file system access)
  routes.forEach(route => {
    if (!route.component) {
      issues.push({
        type: 'missing_component',
        path: route.path,
        message: `Missing component definition for route: ${route.path}`
      });
    }
  });
  
  return issues;
};

export default routeConfig;